import { createAction, props } from '@ngrx/store';

export const setPrices = createAction('[PRICES] Set Prices', props<{ prices }>());
